import React from 'react';
import BreakdownRingChart from '../../../../../../../shared/designSystem/components/BreakdownRingChart';

// TransactionPublisherRingChart — thin adapter for the shared BreakdownRingChart.
//
// V2 publishers surface Impressions + Transactions. Parent aliases
// `transactions` → `totalTransactions` per row; whichever dimension key
// flows down, the shared chart reads the matching item field directly.
const TransactionPublisherRingChart = ({
  data,
  height,
  selectedPublisherDimension = 'impressions',
}) => (
  <BreakdownRingChart
    data={data}
    dimension={selectedPublisherDimension}
    height={height}
  />
);

export default TransactionPublisherRingChart;
